import { memo } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IntegrationAccount } from "app/pages/sales-intelligence/modules/company-analysis/types/crm-links";

import AccountsDropdown from "../AccountsDropdown/AccountsDropdown";

import { StyledMultipleAccountsTag } from "./styles";

export type MultipleAccountsTagProps = {
    accounts: readonly IntegrationAccount[];
    onAccountClick?: (account: IntegrationAccount) => void;
};

const MultipleAccountsTag = ({ accounts, onAccountClick }: MultipleAccountsTagProps) => {
    const multipleAccountsLabel = translate("si.account-overview.integration-tag.multiple");

    return (
        <AccountsDropdown
            accounts={accounts}
            ariaLabel={multipleAccountsLabel}
            dataAutomationPrefix="integration-multiple-accounts"
            onAccountClick={onAccountClick}
        >
            <StyledMultipleAccountsTag>
                <span data-automation="integration-text">{multipleAccountsLabel}</span>
            </StyledMultipleAccountsTag>
        </AccountsDropdown>
    );
};

export default memo(MultipleAccountsTag);
